import $ from 'jquery';
import { Rectangle } from 'leaflet/src/layer/vector/Rectangle';
import * as i18n from 'i18n-setup';
import * as Doc from 'doc';
import style from 'style';
import state from 'state';

state.matches = null;

export function search() {
    var panel = panel.search,
        form = $('form', panel),
        input = $('input', form).first(),
        result = $('<div/>').appendTo(form),
        createLI = function (m) {
            var li = $('<li/>'),
                a = $('<a/>');
            li.attr('value', 1 + m.page);
            a.attr('href', 'search: ' + i18n.str('search.match').replace('{page}', 1 + m.page));
            a.html(m.context);
            a.click(function (e) {
                e.preventDefault();
                Doc.changePage(m.page);
                var mapBound = state.map.getBounds(),
                    mapCenter = mapBound.getCenter(),
                    fullWidth = [ [ mapCenter.lat, 0 ], [ mapCenter.lat, state.info.pagesize[m.page].w ] ],
                    myBound = Doc.convertPos(m.positions[0]);
                for (var i = 1; i < m.positions.length; ++i)
                    myBound.extend(Doc.convertPos(m.positions[i]));
                var myCenter = myBound.getCenter();
                if (mapBound.contains(fullWidth)) // if full page width is visible
                    myCenter.lng = mapCenter.lng; // then only center vertically
                state.map.panTo(myCenter);
            });
            a.appendTo(li);
            return li;
        },
        clear = function () {
            state.matches = null;
            highlight();
            result.empty();
        };
    panel.on('preOpen', function () {
        // if search was externally reset, clear results
        if (state.matches === null)
            clear();
    });
    panel.on('afterOpen', function () {
        input.focus(); // to allow key-only usage
        input.select(); // to ease overwriting
    });
    input.change(function () {
        // if input was cleared, clear results
        if (!input.val().length)
            clear();
    });
    form.submit(function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        search(input.val());
    });
    return function (term) {
        // do a new search
        state.matches = null;
        highlight();
        result.empty();
        if (!term.length)
            return;
        $('<p/>').i18n('search.searching').appendTo(result);
        $.getJSON(state.base + 'search.json', {
            term: term
        }).then(function (json) {
            if (!('matches' in json))
                return;
            // update highlights of current page
            state.matches = json.matches;
            highlight();
            // create list
            result.empty();
            if (!state.matches.length) {
                $('<p/>').i18n('search.empty').appendTo(result);
                return;
            }
            var lastPage, ul, m;
            for (var i = 0; i < state.matches.length; ++i) {
                m = state.matches[i];
                if (m.more) {
                    $('<p/>').i18n('search.tooMany').appendTo(result);
                    break;
                }
                if (m.page != lastPage) {
                    lastPage = m.page;
                    $('<p/>').text(
                        i18n.str('search.page').replace('{page}', 1 + m.page)
                    ).appendTo(result);
                    ul = $('<ul/>').appendTo(result);
                }
                ul.append(createLI(m));
            }
        }).catch(function () {
            result.empty();
            $('<p/>').i18n('search.error').appendTo(result);
        });
    };
}

export function highlight() {
    Doc.layer.search.clearLayers();
    if (state.matches)
        for (var i = 0; i < state.matches.length; ++i)
            if (state.matches[i].page == state.page)
                for (var j = 0; j < state.matches[i].positions.length; ++j)
                    Doc.layer.search.addLayer(
                        new Rectangle(Doc.convertPos(state.matches[i].positions[j]), style.search));
}
